export enum userAuthenticationStatus {
  VERIFICATION_PENDING = 'email_verification_pending',
  COMPANY_INFO_PENDING = 'company_info_pending',
  COMPANY_ADDRESS_PENDING = 'company_address_pending',
  PAYMENT_PENDING = 'payment_pending',
  ACTIVE = 'active',
}

export enum apiProps {
  DATA = 'data',
  TOKEN = 'token',
  USER = 'user',
  USER_DETAILS = 'userDetails',
  COMPANY = 'company',
}
